import { render } from "./PrivacyMockado.vue?vue&type=template&id=00950445&lang=true"
import script from "./PrivacyMockado.vue?vue&type=script&lang=js"
export * from "./PrivacyMockado.vue?vue&type=script&lang=js"
script.render = render

export default script